import { default as api } from 'config/adminApiConf.js';

export const listProductRequest = async (page) => {
	try {
		let result = await api.get(`/products/list-product-request?page=${page}`);
		return result;
	} catch (error) {
		return error;
	}
};
export const acceptProductRequest = async (data) => {
	try {
		let result = await api.post(`/products/accept-product-request`, data);
		return result;
	} catch (error) {
		return error;
	}
};
